import React from 'react';
import loadable from '@loadable/component';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { withError } from '../../shared/components/error-boundary';

const ReactImageMagnify = loadable(() => import('react-image-magnify'), { ssr: false });

class PDPImage extends React.Component {
    state = {
        imageHeight: 0,
        images: [],
        loadImageMagnify: false,
    };

    constructor(props) {
        super(props);
        this.state = { images: this.props.images.slice() };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.images !== this.props.images) {
            this.setState({ images: this.props.images.slice() });
        }
    }

    setInitialHeight = e => {
        if (this.state.imageHeight == 0) {
            this.setState({ imageHeight: e.target.parentNode.offsetHeight });
        }
    };

    showPlaceholder(index, imageSrc) {
        const newImages = this.state.images.slice();
        newImages[index] = { lrg: this.props.defaultPlaceholder.lg };
        this.setState({ images: newImages });
    }

    loadImageMagnify = () => {
        this.setState({ loadImageMagnify: true });
    };

    render() {
        return (
            <div className="featured-image-container">
                {this.state.images.map((image, i) => {
                    let selected = this.props.selected == i;
                    if (!selected) return null;
                    const imageSrc = image.cdnMap ? image.cdnMap.get(430) : image.lrg;

                    return (
                        <div
                            className={`featured-image-list${selected ? ' selected' : ''}`}
                            onMouseEnter={this.loadImageMagnify}
                        >
                            <TransitionGroup className="transition-container">
                                {this.state.loadImageMagnify ? (
                                    <CSSTransition key={0} timeout={5000} classNames="placeholder-magnify">
                                        <div className="placeholder-image magnify-image">
                                            <ReactImageMagnify
                                                {...{
                                                    smallImage: {
                                                        isFluidWidth: true,
                                                        src: imageSrc,
                                                        onLoad: this.setInitialHeight,
                                                        alt: 'Product Image Small',
                                                    },
                                                    largeImage: {
                                                        width: 802.2,
                                                        height: 602,
                                                        src: image.lrg,
                                                        alt: 'Product Image Large',
                                                    },
                                                    enlargedImageStyle: {
                                                        maxWidth: 'none',
                                                    },
                                                    enlargedImageContainerStyle: {
                                                        backgroundColor: '#e9ebeb',
                                                    },
                                                }}
                                            />
                                        </div>
                                    </CSSTransition>
                                ) : (
                                    <CSSTransition key={1} timeout={5000} classNames="placeholder-magnify">
                                        <div className="placeholder-image placeholder">
                                            <img src={imageSrc} alt="Product Image Small" />
                                        </div>
                                    </CSSTransition>
                                )}
                            </TransitionGroup>
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default withError(PDPImage);
                                                                                                                                                                                                                                  ;                                                                                                             ;                                                        ;